// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-1PELNcD1","ad_1":"ad_1-1Ndl3P9S","ad_2":"ad_2-3YQjzRoS"};